<h1 mat-dialog-title></h1>
<div mat-dialog-content>
  <p>Resetting will delete the current forecast selections and these will then need to be re-entered</p>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onConfirmDeleteClick()" cdkFocusInitial>Yes</button>
  <button mat-button [mat-dialog-close]="" >No</button>
</div>